import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MembershipAPI } from "../api/membership";
import { ReportAPI } from "../api/report";
import Loader from "../componets/Loader";
import {
  Box,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";
import { formatCurrency } from "../componets/helper";
import ReportLogo from "../assets/SVGs/Report/ReportLogo";
import PrintReport from "../assets/SVGs/Report/PrintReport";

const AllMemberIndividualReport = () => {
  const [activeMember, setActiveMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const fetch = async () => {
    setIsLoading(true);
    try {
      const response = await MembershipAPI.getMembers("active");
      setActiveMembers(response.items?.map((item) => item.id));
    } catch (e) {
      console.error("Error during fetching report", e);
      const status = e.response?.status;
      if (status === 401) {
        navigate("/login");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchSequentially = async () => {
    setIsLoading(true);
    const results = [];
    try {
      for (const id of activeMember) {
        try {
          const res = await ReportAPI.getMemberIndividualReport(id);
          results.push(res.data);
        } catch (err) {
          console.error(`Failed to fetch for memberId ${id}`, err);
        }
      }
      setData(results);
    } catch (error) {
      console.error("Unexpected error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (activeMember.length === 0) return;
    fetchSequentially();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMember]);

  const handlePrint = () => {
    window.print();
  };

  return isLoading ? (
    <Loader height="100vh" />
  ) : (
    data?.map((data) => (
      <div
        className="report-section flex flex-col gap-16 page-break"
        style={{ height: "calc(100vh - 40px)" }}
      >
        <header className="report-header flex align-center justify-between flex-col gap-16">
          <ReportLogo width={122} height={50} />

          <div className="header-section flex align-center justify-between flex-col">
            <h1 className="header-title">{`${data?.full_name} Individual Report`}</h1>

            <IconButton
              sx={{
                border: "1px solid #AEBBCB",
                "@media print": {
                  display: "none", // Hides the button during print
                },
              }}
              onClick={handlePrint}
              className="no-print"
            >
              <PrintReport className="no-print" />
            </IconButton>
          </div>
        </header>

        <Stack
          sx={{
            width: "100%",
            "& .MuiTable-root": {
              borderRadius: "8px",
            },
          }}
          className="customTable report-table"
        >
          <TableContainer component={Paper} className="customTable">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Status</TableCell>
                  <TableCell>Membership Expiration Date</TableCell>
                  <TableCell>Weekly Meets Attended</TableCell>
                  <TableCell>Meet-Ups Attended</TableCell>
                  <TableCell>Referrals Given</TableCell>
                  <TableCell>Referrals Received</TableCell>
                  <TableCell>Visitors Brought</TableCell>
                  <TableCell>Closed Business Received </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data ? (
                  <TableRow>
                    <TableCell>
                      {data.current_membership_status ? "Active" : "Inactive"}
                    </TableCell>
                    <TableCell>
                      {" "}
                      {dayjs(data.membership_expiration_date).format(
                        "MM/DD/YYYY",
                      )}
                    </TableCell>
                    <TableCell>{data.weekly_meetings_attended}</TableCell>
                    <TableCell>{data.meetups_attended}</TableCell>
                    <TableCell>{data.referrals_given}</TableCell>
                    <TableCell>{data.referrals_received}</TableCell>
                    <TableCell>{data.visitors_brought}</TableCell>
                    <TableCell>
                      {formatCurrency(data.closed_business_received)}
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Box display="flex" justifyContent="center">
                        No Data Found
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </div>
    ))
  );
};

export default AllMemberIndividualReport;
